/**
 * CommentCreateReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * CommentCreateReq
 */
export interface CommentCreateReq {
  /** 评论目标类型 */
  target_type: string
  /** 评论目标ID */
  target_id: string
  /** 评论内容 */
  text?: string
  file_ids?: string[]
  /** 回复的评论ID */
  reply_to_comment_id?: any
  /** 发布者用户ID（为空则使用官方账号） */
  author_id?: any
}

/**
 * CommentCreateReq Schema
 */
export const CommentCreateReqSchema: SchemaDefinition = {
  properties: {
    target_type: {
      description: '评论目标类型',
      format: 'cons.CommentTargetType',
      type: 'string',
      label: '评论目标类型',
    },
    target_id: {
      description: '评论目标ID',
      format: 'string',
      type: 'string',
      label: '评论目标ID',
    },
    text: {
      description: '评论内容',
      format: 'string',
      type: 'string',
      label: '评论内容',
    },
    file_ids: {
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
    },
    reply_to_comment_id: {
      description: '回复的评论ID',
      format: 'string',
      type: 'comment',
      label: '回复的评论ID',
    },
    author_id: {
      description: '发布者用户ID（为空则使用官方账号）',
      format: 'string',
      type: 'user',
      label: '发布者用户ID',
    },
  },
  required: ['target_type', 'target_id'],
  type: 'object',
}
